import { render } from "./AddMouvementFiche.vue?vue&type=template&id=4a77c8c0&ts=true"
import script from "./AddMouvementFiche.vue?vue&type=script&lang=ts"
export * from "./AddMouvementFiche.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__